import VueRouter from 'vue-router'

import Home from '../views/Home.vue'
import Login from '../views/Login.vue'
import Unsubscribe from '../views/Unsubscribe.vue'
import TestErrors from '../views/TestErrors'
import NotFound from '../views/NotFound'
import PaymentSuccess from '../views/PaymentSuccess'
import PaymentFailed from '../views/PaymentFailed'

const routes = [
	{
		path: '/',
		name: 'Home',
		component: Home,
	},
	{
		path: '/unsubscribe',
		name: 'Unsubscribe',
		component: Unsubscribe,
	},
	{
		path: '/chat/:roomId',
		name: 'Chat',
		component: Home,
		props: true,
	},
	{
		path: '/msgs/:messageId',
		name: 'Message',
		props: true,
		component: Home
	},
	{
		path: '/login',
		component: Login,
		props: route => ({query: route.query.login_token})
	},
	{
		path: '/general/error',
		component: TestErrors,
	},
	{
		path: '/payment-success',
		component: PaymentSuccess,
	},
	{
		path: '/payment-failed',
		component: PaymentFailed,
	},
	{
		path: '/:catchAll(.*)',
		component: NotFound,
	},

]

const router = new VueRouter({
	mode: 'history',
	base: '/',
	routes
});


export default router